import { Box, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { StatusPill } from "../../../../components/ui/status-pill"
import classes from "../analytics.module.css"
import { SalesAnalyticsIncompleteOrders } from "../types"
import { formatCompactMnt, formatInt, formatMonthDay } from "../utils"
import { AnalyticsCard, EmptyRow } from "./AnalyticsCard"

type Props = {
  data: SalesAnalyticsIncompleteOrders | undefined
  isLoading: boolean
}

export function IncompleteOrders({ data, isLoading }: Props) {
  const { t } = useTranslation(["dashboard"])
  const rows = data?.data.rows ?? []

  return (
    <AnalyticsCard
      title={t("analytics.incomplete.title", { defaultValue: "Гүйцэтгэж дуусаагүй" })}
      subtitle={t("analytics.incomplete.subtitle", { defaultValue: "Сануулга шаардлагатай захиалгууд" })}
      isLoading={isLoading}
    >
      {rows.length === 0 && !isLoading ? <EmptyRow /> : null}
      {rows.map(row => {
        const amt = formatCompactMnt(row.orderAmount)
        return (
          <Box key={row.orderId} className={classes.pendingRow}>
            <Box flex={1} miw={0}>
              <Text className={classes.pendingNo}>{row.orderNumber} · {row.partnerName}</Text>
              <Text className={classes.pendingMeta}>
                {formatInt(row.lineCount)} {t("analytics.tables.pieces", { defaultValue: "ш" })} · {formatMonthDay(row.respondedDate)}
              </Text>
            </Box>
            <Text className={classes.amount}>{amt.display} {amt.unit}</Text>
            {/* Waiting on someone = the yellow status tone (dot + dark text), like every status pill. */}
            <StatusPill tone="yellow">
              {row.daysOpen} {t("analytics.incomplete.days", { defaultValue: "хоног" })}
            </StatusPill>
          </Box>
        )
      })}
    </AnalyticsCard>
  )
}
